var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 268,
    viewBox: "0 0 206 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.72 49.128L175.736 10.3572L191.231 28.352L146.22 67.1228L130.72 49.128Z",
    fill: "#F0573E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 0,
    width: 57,
    height: 54
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.814 0.69043H205.158V53.9092H149.814V0.69043Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.158 0.69043L187.251 53.7842L168.621 32.154L149.996 10.5238L177.574 5.6071L205.158 0.69043Z",
    fill: "#F0573E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_248_951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 190,
    width: 27,
    height: 78
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9702 190.29H101.246V267.29H75.9702V190.29Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_248_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.7204 267.289C81.7985 267.3 76.1735 261.701 76.1631 254.779L76.0381 190.487L101.106 190.435L101.231 254.732C101.241 261.654 95.6423 267.274 88.7204 267.289Z",
    fill: "#F0573E"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.471 245.602L69.8977 245.675C62.9758 245.69 57.356 240.086 57.3404 233.164C57.3247 226.243 62.9289 220.623 69.8508 220.607L107.424 220.534C114.346 220.524 119.971 226.123 119.981 233.045C119.997 239.966 114.398 245.591 107.471 245.602Z",
    fill: "#F0573E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_248_951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 61,
    width: 146,
    height: 140
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.459961 61.9978H145.486V200.664H0.459961V61.9978Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_248_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.002 163.347C114.71 170.67 102.127 174.967 88.5589 174.946C53.7568 174.894 25.4756 146.3 25.7933 111.498C25.8975 100.409 28.8818 89.9926 34.0433 80.977C37.111 75.6072 35.7985 68.7999 31.0016 64.8989C24.9339 59.9718 15.8766 61.6333 12.0068 68.4197C10.2933 71.4249 8.75684 74.5343 7.39746 77.7478C2.79329 88.628 0.459961 100.18 0.459961 112.081C0.459961 123.982 2.79329 135.534 7.39746 146.415C11.8402 156.92 18.1943 166.352 26.2933 174.446C34.387 182.54 43.8193 188.899 54.3245 193.342C65.2048 197.946 76.7568 200.279 88.6579 200.279C100.559 200.279 112.111 197.946 122.991 193.342C128.897 190.842 134.46 187.743 139.642 184.066C146.059 179.508 146.866 170.295 141.304 164.727C136.934 160.357 130.043 159.763 125.002 163.347Z",
    fill: "#F0573E"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.783 144.925C175.507 134.097 177.97 122.571 178.106 110.675C178.236 98.7737 176.033 87.1956 171.554 76.2633C167.231 65.7112 160.981 56.206 152.976 48.0237C144.97 39.8362 135.611 33.3727 125.158 28.8154C114.33 24.0862 102.804 21.6227 90.9027 21.4925C79.0016 21.357 67.4287 23.5602 56.4912 28.0445C50.5589 30.4716 44.96 33.5133 39.7412 37.1331C33.2725 41.6122 32.361 50.8206 37.861 56.4508C42.1839 60.8675 49.0641 61.5341 54.1423 58.0133C64.512 50.8102 77.1371 46.6539 90.6943 46.8206C125.241 47.2477 153.121 75.7633 152.778 110.315C152.674 120.492 150.142 130.081 145.746 138.55C142.96 143.92 144.33 150.503 149.043 154.295C155.262 159.295 164.538 157.399 168.21 150.321C169.127 148.555 169.986 146.758 170.783 144.925Z",
    fill: "#F0573E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.814 93.5134H63.7515C59.9546 93.5134 56.8452 96.6228 56.8452 100.425C56.8452 104.222 59.9546 107.331 63.7515 107.331H115.814C119.616 107.331 122.725 104.222 122.725 100.425C122.725 96.6228 119.616 93.5134 115.814 93.5134Z",
    fill: "#F0573E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.814 113.894H63.7515C59.9546 113.894 56.8452 117.003 56.8452 120.8C56.8452 124.602 59.9546 127.711 63.7515 127.711H115.814C119.616 127.711 122.725 124.602 122.725 120.8C122.725 117.003 119.616 113.894 115.814 113.894Z",
    fill: "#F0573E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.65a9b2e151bccc2b2c2cea9d33ed3ea4.svg";
export { ForwardRef as ReactComponent };